import { useAuthWithTestMode } from "@/hooks/use-auth-with-test-mode";
import { useTranslation } from "react-i18next";

export function WorkOSImpersonationBanner() {
  const { t } = useTranslation();
  const { impersonator, user } = useAuthWithTestMode();
  if (!impersonator) return null;

  const reason = impersonator.reason?.trim();
  const target = user?.email ?? t("auth.thisUser");

  return (
    <aside
      aria-live="polite"
      className="flex min-h-8 w-full shrink-0 items-center justify-center border-b border-amber-700 bg-amber-300 px-3 py-1 text-center text-xs font-semibold text-amber-950 shadow-sm dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200"
      data-testid="workos-impersonation-banner"
      role="status"
    >
      <span>
        {reason
          ? t("auth.impersonationBannerWithReason", {
            target,
            email: impersonator.email,
            reason,
          })
          : t("auth.impersonationBanner", { target, email: impersonator.email })}
      </span>
    </aside>
  );
}
